import { Component } from '@angular/core';

@Component({
  selector: 'app-shimmer-effect',
  imports: [],
  templateUrl: './shimmer-effect.html',
  styleUrl: './shimmer-effect.css',
})
export class ShimmerEffect {

}
